import { KnownChainIds } from '@shapeshiftoss/types'

export const STONFI_SUPPORTED_CHAIN_IDS = [KnownChainIds.TonMainnet] as const

export const STONFI_WEBSOCKET_URL = 'wss://omni-ws.ston.fi'

export const STONFI_DEFAULT_SLIPPAGE_BPS = 100

export const STONFI_QUOTE_TIMEOUT_MS = 30000
